import { useState } from "react";

interface Tab {
  id: string;
  label: string;
  active?: boolean;
}

export default function OneSTopBar() {
  const [tabs, setTabs] = useState<Tab[]>([
    { id: "nav", label: "Навигация", active: false },
    { id: "home", label: "Начальная страница", active: false },
    { id: "check", label: "Работа с 1С [ПО] для проверки маркировочной продукции", active: false },
    { id: "orders", label: "Заказы клиентов", active: true },
  ]);

  const setActive = (id: string) => {
    setTabs((prev) => prev.map((t) => ({ ...t, active: t.id === id })));
  };

  return (
    <div className="h-[32px] flex items-center bg-[#FFF9E6] border-b border-[#D5CA8A] px-1 gap-0 select-none"
      style={{ fontFamily: "'Segoe UI', Tahoma, Geneva, Verdana, sans-serif" }}
    >
      <button className="flex items-center gap-1 px-2 py-1 text-[#666666] hover:bg-[#FDF2B5] rounded cursor-pointer text-[11px] transition-colors"
      >
        <i className="ri-arrow-left-s-line text-[11px]"></i>
      </button>
      <button className="flex items-center gap-1 px-2 py-1 text-[#666666] hover:bg-[#FDF2B5] rounded cursor-pointer text-[11px] transition-colors"
      >
        <i className="ri-arrow-right-s-line text-[11px]"></i>
      </button>
      <div className="w-px h-4 bg-[#D5CA8A] mx-1" />

      {tabs.map((tab) => (
        <button
          key={tab.id}
          onClick={() => setActive(tab.id)}
          className={`flex items-center gap-1 px-3 py-1 text-[11px] rounded-t cursor-pointer transition-colors border border-b-0 ${
            tab.active
              ? "bg-white text-[#2D2D2D] border-[#D5CA8A] font-medium"
              : "bg-[#FFF9E6] text-[#666666] border-[#FFF9E6] hover:bg-[#FDF2B5]"
          }`}
        >
          {tab.id === "orders" && <i className="ri-file-list-2-line text-[10px]"></i>}
          {tab.id === "home" && <i className="ri-home-4-line text-[10px]"></i>}
          {tab.id === "nav" && <i className="ri-menu-line text-[10px]"></i>}
          {tab.id === "check" && <i className="ri-star-line text-[10px]"></i>}
          {tab.label}
          {tab.active && (
            <i className="ri-close-line text-[10px] hover:text-[#666666] ml-1"></i>
          )}
        </button>
      ))}

      <div className="ml-auto flex items-center gap-1 pr-2 text-[10px]"
      >
        <span className="text-[#666666]">Методическая база</span>
        <span className="text-[#666666]">/</span>
        <span className="text-[#666666]">Управление торговлей</span>
        <span className="text-[#666666]">/</span>
        <span className="text-[#2D2D2D] font-medium">Заказы клиентов</span>
      </div>
    </div>
  );
}